import React, { InputHTMLAttributes, useCallback } from 'react';
import { createUseStyles } from 'react-jss';

export interface RadioProps {
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: (name: string, value: any) => any;
}

const Radio: React.FC<RadioProps> = ({
  checked,
  value,
  onChange,
  ...others
}) => {
  const classes = useStyles();

  const toggleCheck = useCallback(() => {
    if (typeof onChange === 'function') {
      onChange(others.name as string, value);
    }
  }, [value, others.name, onChange]);

  return (
    <div className={classes.container} onClick={toggleCheck}>
      <input type="radio" {...others} checked={checked} />
      <span
        className={classes.checkmark}
        style={{ borderColor: checked ? '#41DB92' : '#dadada' }}
      />
    </div>
  );
};

export default Radio;

const useStyles = createUseStyles({
  /* Customize the label (the container) */
  container: {
    display: 'inline-block',
    position: 'relative',
    paddingLeft: '35px',
    marginBottom: '12px',
    cursor: 'pointer',
    fontSize: '22px',
    userSelect: 'none',
    height: '25px',
    '& input': {
      /*  Hide the browser's default Radio  */
      position: 'absolute',
      opacity: 0,
      cursor: 'pointer',
      height: 0,
      width: 0,
      /* Show the checkmark when checked */
      '&:checked': {
        '& ~ $checkmark': {
          /* When the Radio is checked, add a blue background */
          '&:after': {
            display: 'block',
          },
        },
      },
    },

    '& $checkmark': {
      '&:after': {
        left: '9px',
        top: '5px',
        width: '5px',
        height: '10px',
        border: 'solid #41DB92',
        borderWidth: '0 3px 3px 0',
        transform: 'rotate(45deg)',
      },
    },
  },

  checkmark: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '25px',
    width: '25px',
    borderRadius: '50%',
    border: '2px solid',
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'none',
    },
  },
});
